import { render, staticRenderFns } from "./paperConfirmOrder.vue?vue&type=template&id=6342e91e&scoped=true"
import script from "./paperConfirmOrder.vue?vue&type=script&lang=js"
export * from "./paperConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./paperConfirmOrder.vue?vue&type=style&index=0&id=6342e91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6342e91e",
  null
  
)

export default component.exports